import { createFeatureSelector, createSelector } from '@ngrx/store'
import { SELECTED_PROFILE_FEATURE_KEY, SelectedProfileState } from './selected-profile.reducer'

export const getSelectedProfileState = createFeatureSelector<SelectedProfileState>(SELECTED_PROFILE_FEATURE_KEY)

export const getSelectedProfile = createSelector(getSelectedProfileState, (selectedProfileState) =>
  // return state if profile has loaded data
  selectedProfileState.email ||
  selectedProfileState.phone_number ||
  selectedProfileState.invite_email ||
  selectedProfileState.invite_phone_number
    ? selectedProfileState
    : undefined,
)

export const getSelectedProfileLoaded = createSelector(
  getSelectedProfileState,
  (selectedProfileState) => selectedProfileState.loaded,
)

export const getSelectedProfileId = createSelector(
  getSelectedProfileState,
  (selectedProfileState) => selectedProfileState.uuid,
)

export const getSelectedProfileFirstName = createSelector(
  getSelectedProfile,
  (selectedProfile) => selectedProfile?.first_name,
)

export const getSelectedProfileStripeCustomer = createSelector(
  getSelectedProfile,
  (selectedProfile) => selectedProfile?.stripe_customer,
)

export const getSelectedProfileUser = createSelector(
  getSelectedProfile,
  (selectedProfile) => selectedProfile?.user?.uuid,
)

export const getSelectedProfileCreditCardRequired = createSelector(
  getSelectedProfile,
  (selectedProfile) => !!selectedProfile?.credit_card_required,
)

export const getSelectedProfileCustomValues = createSelector(
  getSelectedProfile,
  (selectedProfile) => selectedProfile?.custom_registration_values || [],
)
